import { useConfiguration } from './useConfiguration'

/**
 * Returns whether the Duties Metrics dashboard is enabled for the current
 * organization.
 *
 * The sidebar link's read of the gate. The route does not come through here —
 * it wraps in `ProtectedFeatureRoute`, which reads the same flag off the same
 * config query — so removing the rollout is a grep-and-delete on both
 * `useDutyMetricsEnabled` and the `featureFlag: 'duty_metrics'` gate on the
 * duties.metrics entry in `src/config/routeManifest.ts`. The two must agree on
 * the org-switch guard
 * below, or the row and the page disagree mid-switch.
 *
 * Note this governs *access to the page*, which used to be Careforce
 * super-user only. It deliberately does not govern the page's cross-org scope:
 * the org filter's "All organizations" option is still super-user, because the
 * relay enforces that boundary itself and answers 403 to anyone else.
 */
export function useDutyMetricsEnabled(): boolean {
  const { configuration, isPreviousOrgData } = useConfiguration()
  // During an org switch the config query serves the previous org's data under
  // the new org's id, so trusting it would carry one org's rollout into another.
  if (isPreviousOrgData) return false
  return configuration?.features?.duty_metrics ?? false
}
